module.exports = __webpack_public_path__ + "static/Customer-Loyalty-Program-ef65684095d17a0d8a4bff1e43ed0ccf.jpg";